exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n/* 可以添加一些样式来调整图表的外观 */\r\n", ""]);

// exports
